import React from "react"
import { ITabsProps, Tabs } from "@blueprintjs/core"
import classNames from "utils/classNames"

interface CustomVerticalTabsProps extends Omit<ITabsProps, "id"> {}

const CustomVerticalTabs = ({
  children,
  className,
  ...otherProps
}: CustomVerticalTabsProps) => {
  return (
    <Tabs
      className={classNames("vt-custom-vertical-tabs", className)}
      vertical
      {...otherProps}
    >
      {children}
    </Tabs>
  )
}

export default CustomVerticalTabs
